export const SET_INVOICE = 'setInvoice'
export const SET_INVOICES = 'setInvoices'
export const SET_INVOICES_SIMPLE = 'setInvoicesSimple'
export const SET_CATEGORIES = 'setCategories'
export const SET_INVOICE_ACTIVE = 'setInvoiceActive'
export const INVOICE_RESET = 'setReset'
export const INVOICE_RESET_STATE = 'setInvoiceResetState'
export const SET_INVOICE_PAGINATION = 'setInvoicePagination'